import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async downloadDerivative(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const content = await axios.get(`/autodesk/model-derivative/model-derivative/manifest/${data.derivativeId}/download?urn=${data.derivativeUrn}`, config);
        return content.data;
      } catch (error) {
        throw error;
      }
    },

    async getManifest(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const content = await axios.get(`/autodesk/model-derivative/model-derivative/manifest/${data.derivativeId}`, config);
        return content.data;
      } catch (error) {
        throw error;
      }
    },

    async runJob(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const content = await axios.post('/autodesk/model-derivative/model-derivative/job', data.data, config);
        return content.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
